<template>
  <ProgramKeyIndicatorContainer
    :class="{
      'shadow-none': fullScreen
    }"
  >
    <div class="flex flex-col flex-1 min-h-0">
      <div v-if="!fullScreen" class="text-sm flex items-center justify-between">
        <span>{{ data.label }}</span>
      </div>
      <div class="relative flex-1 min-h-0">
        <Pie
          :data="chartData"
          :options="fullScreen ? fullScreenOptions : previewOptions"
        />
      </div>
      <div class="text-sm">
        {{ data.extra }}
      </div>
    </div>
  </ProgramKeyIndicatorContainer>
</template>

<script lang="ts" setup>
import {Pie} from 'vue-chartjs';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
    ArcElement,
    ChartOptions
} from 'chart.js';
import {computed} from 'vue';
import ProgramKeyIndicatorContainer from "@/program/components/program-statistics/ProgramKeyIndicatorContainer.vue";
import ProgramKeyIndicatorOptions from "@/program/services/ProgramKeyIndicatorOptions";
import {BinomialPieChartMarketStatistic} from "@/program/interfaces/Program";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement);

const {fullScreen = false, data} = defineProps<{
    fullScreen?: boolean;
    data: BinomialPieChartMarketStatistic;
}>();

const chartData = computed(() => {
    return {
        labels: data.value.map(item => item.name),
        datasets: [{
            backgroundColor: [
                '#41b8a6',
                '#409488',
                '#E46651',
                '#b95342',
                '#7741b8',
                '#5d3696',
                '#e451d0',
                '#cb50b7',
                '#c9a779',
                '#9f754c',
                '#3e80c2',
                '#4e7ba4'
            ],
            data: data.value.map(item => item.count)
        }]
    };
});

const chartOptions: ChartOptions<"pie"> = {
    ...ProgramKeyIndicatorOptions.chartDefaultOptions,
    elements: {
        arc: {
            borderWidth: 0
        }
    }
};

const previewOptions = computed<ChartOptions<"pie">>(() => ({
    ...chartOptions,
    ...ProgramKeyIndicatorOptions.chartPreviewOptions
} as ChartOptions<"pie">));

const fullScreenOptions = computed<ChartOptions<"pie">>(() => ({
    ...chartOptions,
    ...ProgramKeyIndicatorOptions.chartFullScreenOptions
} as ChartOptions<"pie">));
</script>
